import React, { Component } from 'react';

export class Footer extends Component {
  render() {
    return (
      <div className="page-wrapper-row">
          <div className="page-wrapper-bottom">
              <div className="page-footer">
                  <div className="container"> 2017, 2018 releva.nz &copy; by
                      <a target="_blank" href="https://releva.nz"> releva GmbH</a>
                  </div>
              </div>
              <div className="scroll-to-top">
                  <i className="icon-arrow-up"></i>
              </div>
          </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js